const stages = [
  { title: "Upload your data", description: "Select the data you want to upload" },
  { title: "Verify data", description: "Make sure everything is as it should be" },
  { title: "Upload", description: "One final check to make sure everything is ok" },
];
export default stages;